import { render } from "./providerSurveyResults.vue?vue&type=template&id=2db37b94&scoped=true&ts=true"
import script from "./providerSurveyResults.vue?vue&type=script&lang=ts"
export * from "./providerSurveyResults.vue?vue&type=script&lang=ts"

import "./providerSurveyResults.vue?vue&type=style&index=0&id=2db37b94&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db37b94"]])

export default __exports__